import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { isEmpty } from '@hsp/utilities';

import { globalQueryKeys } from 'hooks/queries/query-keys';
import { lookupService } from 'services';
import { IDataContainer, IResult } from 'types/api/common';
import { IDistrict } from 'types/api/districts';

export const useFetchDistricts = (byState = false, state?: string) => {
  return useQuery({
    queryFn: async () => {
      return await lookupService.getDistricts();
    },
    queryKey: globalQueryKeys.districts,
    select: useCallback(
      (data: IResult<IDataContainer<IDistrict[]>> | undefined) => {
        const districts = data?.dataContainer?.data ?? [];

        if (!byState) {
          return districts;
        }

        if (isEmpty(state)) {
          return [];
        }

        return districts.filter(
          ({ state: currentState }) => currentState.toLocaleLowerCase() === state?.toLocaleLowerCase()
        );
      },
      [byState, state]
    ),
  });
};
